import store from "../../index.js";
import api from "../../../utils/api";
import UserConstant from '../../../mixins/user/const/userConstant.js';
import UserAcConstant from '../../../mixins/user/const/userAcConstant.js';
import { bindCurrentSalesAttribution } from '../../../utils/salesAttribution.js';

export const modules = {
    store,
};

export const state = {
    _item: {},
    _error:{}
};

export const mutations = {  
    [UserConstant.ADD_INVITE_ERROR]: (state, payload) => {
        state._error = {code:0, message:''};
        state._error = payload;
    },
    [UserConstant.ADD_VERIFY_INFO]: (state, payload) => {
        state._item = {};
        state._item = payload;
    },
};

export const actions = {
    async acVerifyPhonePrepare({ commit }, payload) {
        const url = UserAcConstant.POST_VERIFY_PHONE_PREPARE;
        try {
            const res = await api.post(url, {...payload});
            if(res?.data?.code === 0 && res?.data?.data?.code === 0){
                commit(UserConstant.ADD_VERIFY_INFO, res?.data?.data);
            }
            return true;
        } 
        catch(error) {
            return false;
        }
    },
    async acVerifyPhonePrepareGuest({ commit }, payload) {
        const url = UserAcConstant.POST_VERIFY_PHONE_PREPARE_GUEST;
        try {
            const res = await api.post(url, {...payload});
            if(res?.data?.code === 0 && res?.data?.data?.code === 0){
                commit(UserConstant.ADD_VERIFY_INFO, res?.data?.data);
            }
            return true;
        } 
        catch(error) {
            return false;
        }
    },
    async acVerifyPhoneResult({ commit }, payload) {
        const url = UserAcConstant.POST_VERIFY_PHONE_RESULT;
        try {
            const res = await api.post(url, {...payload});
            if (res?.data?.code === 0 && res?.data?.data?.result_code === "B000") {
                bindCurrentSalesAttribution();
            }
            return res?.data;
        } 
        catch(error) {
            return null;
        }
    },
    async acVerifyPhoneResultStatus({ commit }, payload) {
        const url = UserAcConstant.POST_VERIFY_PHONE_RESULT_STATUS;
        try {
            const res = await api.post(url, {...payload});
            return res?.data?.code === 0;
        } 
        catch(error) {            
            return false;
        }
    },
    async acVerifyPhoneResultGuest({ commit }, payload) {
        const url = UserAcConstant.POST_VERIFY_PHONE_RESULT_GUEST;
        try {
            const res = await api.post(url, {...payload});
            return res?.data;
        } 
        catch(error) {
            return null;
        }
    },
};

export const getters = {
    geCodeFail: state => {
        switch(state._error.code){

        }    
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
